import { useCardNumberAndCvv, useStoreCardView } from "@usher/pe-client-front-end-lib"
import { Eye, EyeOff } from "lucide-react"
import "./style.sass"

export const CardDetailsCard = () => {
  const { expiryDate } = useStoreCardView((state) => state.card)
  const { cardNumber, cardCvv, toggleAll, cardClosed, cvvToggled, panToggled } = useCardNumberAndCvv()
  const isAllToggled = cvvToggled && panToggled
  return (
    <div className="card-visual">
      <div className="block-one-card_visual_top justify-end">
        {!cardClosed && (
          <div className="block-one-card_visual_view text-gray-300" onClick={toggleAll}>
            {isAllToggled ? <EyeOff size={20} /> : <Eye size={20} />}
          </div>
        )}
      </div>
      <div className="block-one-card_visual_number-card">{cardNumber}</div>
      <div className="block-one-card_visual_bottom">
        <div className="block-one-card_visual_info">
          <div className="block-one-card_visual_label">VALID THRU</div>
          <div className="block-one-card_visual_value">{expiryDate}</div>
        </div>
        <div className="block-one-card_visual_info">
          <div className="block-one-card_visual_label">CVV</div>
          <div className="block-one-card_visual_value">{cardCvv}</div>
        </div>
      </div>
    </div>
  )
}
